export function isBrowserSupported(): boolean {
  const browser = getBrowser();
  return !(browser.name.includes('IE') && (+browser.version < 11));
}

export function isDevice(): boolean {
  return getBrowser().isMobile;
}

export function isMobileDevice(): boolean {
  return window.innerWidth <= 543;
}

export function isTablet(): boolean {
  return window.innerWidth <= 768;
}

export function isSmallDevice(): boolean {
  return window.innerWidth <= 1349;
}

export function getBrowser(): { name: string, version: string, isMobile: boolean } {
  const userAgent = navigator.userAgent;
  const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(userAgent);
  let browserInfo = userAgent.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || [];
  let tem;

  if (/trident/i.test(browserInfo[1])) {
    tem = /\brv[ :]+(\d+)/g.exec(userAgent) || [];

    return {
      name: 'IE',
      version: (tem[1] || ''),
      isMobile
    };
  }

  if (browserInfo[1] === 'Chrome') {
    tem = userAgent.match(/\bOPR|Edge\/(\d+)/);
    if (tem != null) {

      return {
        name: 'Opera',
        version: tem[1],
        isMobile
      };
    }
  }

  browserInfo = browserInfo[2] ? [browserInfo[1], browserInfo[2]] : [navigator.appName, navigator.appVersion, '-?'];
  if ((tem = userAgent.match(/version\/(\d+)/i)) != null) {
    browserInfo.splice(1, 1, tem[1]);
  }

  return {
    name: browserInfo[0],
    version: browserInfo[1],
    isMobile
  };
}


export const extractValue = (target: EventTarget): string => (<HTMLInputElement>target).value;
